module.exports = __webpack_public_path__ + "img/icons_from.38264d06.svg";